import { stopPropagation } from "../../functions/dom";
import { FocusHandler } from "../focus_handlers";
import NodeHandler from "../node_handler";


class TooltipHandler extends NodeHandler{
    __init_dom_schema(){
        return {
            __node__: {
                actions: {
                    'click': stopPropagation,
                }
            },
            popper: {
                selector: '.tooltip-popper',
                actions: {
                    'click': stopPropagation,
                }
            },
            checkbox: {
                selector: '[type="checkbox"]',
                actions: {
                    'change': this.onChange.bind(this)
                }
            },
        }
    }
    __init(){ }
    onChange(event){
        FocusHandler.Focus(this)
    }
    unfocus(){
        this.dom.checkbox.checked = false
    }
}

export {
    TooltipHandler
}